import { Checkbox } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { ButtonLink, ErrorMessage } from './styles';

export const DeclarationCheckbox = ({
  ownerName,
  isAccountAdmin,
  onChange,
  isChecked,
  errorMessage,
  onCreateNewOrg,
}: {
  ownerName: string;
  isAccountAdmin: boolean;
  onChange: (isChecked: boolean) => void;
  isChecked: boolean;
  errorMessage?: string;
  onCreateNewOrg: () => void;
}): JSX.Element => {
  const { t } = useTranslation('account');

  return (
    <Checkbox
      isChecked={isChecked}
      onChange={() => onChange(!isChecked)}
      labelContent={
        <span>
          {t('create-site.declaration-checkbox.hereby', { ownerName })}
          <br />
          <span className="normal">
            {t('create-site.declaration-checkbox.not-the-owner')}
            {isAccountAdmin && (
              <span>
                &nbsp;
                <ButtonLink onClick={onCreateNewOrg} kind="standalone" as="button" type="button">
                  {t('create-site.declaration-checkbox.add-as-new-client')}
                </ButtonLink>
                &nbsp;{t('create-site.or')}
              </span>
            )}
            &nbsp;
            <a href="/register">{t('create-site.declaration-checkbox.create-new-account')}</a>.
          </span>

          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </span>
      }
    />
  );
};
